(() => {
  const protectedContent = 'h1,h2,h3,h4,h5,h6,p,a,button,input,select,textarea,label,summary,dt,dd,li,[role="tab"],[role="status"]';
  const controlSelector = '#carthike-chat-button-container,.progress-wrap';
  let queued = false;
  let scrolling = false;
  let settleTimer;
  let previewElement;
  let previewResize;
  let buyElement;
  let buyResize;
  const topLabel = document.querySelector('script[data-ah-top-label]')?.dataset.ahTopLabel || 'Back to top';

  function updatePreviewOffset() {
    const preview = document.querySelector('#PBarNextFrameWrapper');
    if (preview && previewElement !== preview) {
      previewElement = preview;
      previewResize?.disconnect();
      previewResize = new ResizeObserver(schedule);
      previewResize.observe(preview);
    }
    const rect = preview?.getBoundingClientRect();
    const visible = rect && rect.height > 0 && rect.top < innerHeight && rect.bottom > 0;
    const offset = `${visible ? Math.max(0, innerHeight - rect.top) : 0}px`;
    if (document.body.style.getPropertyValue('--ah-preview-offset') !== offset) {
      document.body.style.setProperty('--ah-preview-offset', offset);
    }
    const buy = document.querySelector('.ab-buy-bar');
    if (buy && buyElement !== buy) {
      buyElement = buy;
      buyResize?.disconnect();
      buyResize = new ResizeObserver(schedule);
      buyResize.observe(buy);
    }
    const buyRect = buy?.getBoundingClientRect();
    const buyVisible = buyRect && buyRect.height > 0 && getComputedStyle(buy).visibility !== 'hidden' && buyRect.top < innerHeight;
    const controlOffset = `${Math.max(parseFloat(offset), buyVisible ? innerHeight - buyRect.top : 0)}px`;
    if (document.body.style.getPropertyValue('--ah-control-offset') !== controlOffset) {
      document.body.style.setProperty('--ah-control-offset', controlOffset);
    }
  }

  function coversContent(control) {
    const rect = control.getBoundingClientRect();
    if (!rect.width || !rect.height) return false;
    const xs = [rect.left - 6, rect.left + rect.width / 2, rect.right + 6];
    const ys = [rect.top - 6, rect.top + rect.height / 2, rect.bottom + 6];
    return xs.some(x => ys.some(y => {
      if (x < 0 || y < 0 || x >= innerWidth || y >= innerHeight) return false;
      return document.elementsFromPoint(x, y).some(element => {
        if (element.closest(controlSelector)) return false;
        const target = element.closest(protectedContent);
        return target && target.closest('main,footer,#MainContent,.rf-footer,.af-footer');
      });
    }));
  }

  function update() {
    queued = false;
    updatePreviewOffset();
    document.querySelector('#carthike-chat-button-container')?.classList.remove('ah-control-obstructed');
    document.querySelectorAll('.progress-wrap').forEach(control => {
      if (!control.dataset.ahReady) {
        control.dataset.ahReady = 'true';
        control.setAttribute('role', 'button');
        control.setAttribute('aria-label', topLabel);
        control.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            control.click();
          }
        });
      }
      if (control.contains(document.activeElement)) return;
      control.classList.toggle('ah-control-obstructed', scrolling || coversContent(control));
      control.tabIndex = control.classList.contains('active-progress') && !control.classList.contains('ah-control-obstructed') ? 0 : -1;
    });
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  }
  window.addEventListener('scroll', () => {
    scrolling = true;
    schedule();
    clearTimeout(settleTimer);
    settleTimer = setTimeout(() => { scrolling = false; schedule(); }, 160);
  }, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  document.addEventListener('load', schedule, true);
  document.addEventListener('focusout', schedule);
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.body, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['hidden']
  });
  new MutationObserver(schedule).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  document.fonts?.ready.then(schedule);
  schedule();
})();
